import { computed } from 'mobx';

import { raceDistancesStore, syncDistancesStore } from '../stores';

export const maxDistances = computed(() => {
  return Math.min(Number(raceDistancesStore.value?.length), Number(syncDistancesStore.value?.length));
});
